import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryContactCreationFailedAction = {
	type: 'BENEFICIARY_CONTACT_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryContactCreationFailedAction => ({
	type: 'BENEFICIARY_CONTACT_CREATION_FAILED',
	payload,
});
